import { Swath } from './Swath.js'
import { SwathManager } from './SwathManager.js'
import { Util } from './Util';

export class PointCloudTimeController {

  static alphaFunction(v){
    return Math.min(v*2.0,1.0);
  }

  constructor({wid, gv, dbFile, path, shader, colormap}){

    this.frames = {};

    this.world = gv.world;
    this.path = path;

    this.shader = shader;
    this.colormap = colormap;

    fetch(dbFile).then(r => r.json()).then(j => {
      this.db = j;
    });

    wid.addTickHandler(this.tickHandler.bind(this));

  }

  percentLoaded(){
    if(!this.db){
      return 0;
    }
    let loadedCount = 0;
    for(const [key, frame] of Object.entries(this.frames)){
      if(frame.loaded){
        loadedCount++
      }
    }
    return loadedCount / Object.keys(this.frames).length * 100;
  }

  tickHandler(simTime, lastSimTime){

    if(!this.db){
      return;
    }

    // Find first item in metadata whos time is greater than current time
    let nextFrameInfo = this.db.find(element => {
      return Util.ms2us(element.time) > simTime.getTime();
    })
    if(!nextFrameInfo){
      nextFrameInfo = this.db[0];
    }

    // Check if we are in new frame
    if(this.currentFrame && this.currentFrame.info.filename == nextFrameInfo.filename){
      return;
    }

    // Get next frame
    let nextFrame = this.frames[nextFrameInfo.filename];

    if(!nextFrame){

      let swath = new Swath({filename: nextFrameInfo.filename});

      SwathManager.fetchFromH3HDF5({
        cloud: swath,
        filename: this.path + nextFrameInfo.filename,
        alphaFunction: PointCloudTimeController.alphaFunction,
        world: this.world,
        pointSize: 1.0,
        shader: this.shader,
        colormap: this.colormap});

      swath.info = nextFrameInfo;

      this.frames[nextFrameInfo.filename] = swath;

      return;

    }

    // Make sure next frame is loaded
    if(!nextFrame.loaded){
      return;
    }

    // Make current frame invisible
    if(this.currentFrame && this.currentFrame.loaded){
      this.currentFrame.geometry.drawRange.count = 0;
    }

    // Next frame is current frame
    this.currentFrame = nextFrame;

    // Make it visible
    if(this.currentFrame.loaded){
      this.currentFrame.geometry.drawRange.count = Infinity;
    }

  }

}